// Feature names granted by plan-features docs, checked against SubscriptionStatus.features
export enum PlanFeature {
    stoppageEvents = "stoppageEvents",
}
